module.exports = __webpack_public_path__ + "img/img5.0bbe11ea.png";